import { BrandLogo } from "../components/BrandLogo/BrandLogo";
import articleHtml from "../../../frontend/marketing/instagram-comments-guide.html?raw";
import guide from "../../../frontend/marketing/instagram-comments-guide.json";
import { usePublicPageMetadata } from "./usePublicPageMetadata";
import "./MarketingHome.css";
import "./SolutionPage.css";
import "./InstagramCommentsGuide.css";

export function InstagramCommentsGuide() {
  usePublicPageMetadata({ ...guide, ogType: "article" });

  return (
    <main className="pm-site ig-guide-site">
      <header className="pm-header">
        <nav className="pm-nav" aria-label="Public navigation">
          <a className="pm-brand" href="/" aria-label="LeadCat CRM homepage">
            <BrandLogo product="crm" variant="lockup" size="small" className="pm-brand-logo" />
          </a>
          <div className="pm-nav-actions">
            <a className="pm-nav-link" href="/instagram-crm/">Instagram CRM</a>
            <a className="pm-nav-link" href="/react/login">Sign in</a>
          </div>
        </nav>
      </header>
      {/* Trusted, repository-authored HTML; the Python public renderer reads the
          same file. Never substitute user, tenant or provider content here. */}
      <div dangerouslySetInnerHTML={{ __html: articleHtml }} />
      <footer className="pm-footer">
        <div className="pm-footer-brand"><a href="/" aria-label="LeadCat CRM homepage"><BrandLogo product="crm" variant="lockup" size="small" className="pm-footer-logo" /></a><p>LeadCat CRM is a product from Staminal Technologies.</p></div>
        <nav aria-label="Legal links"><a href="/privacy.html">Privacy</a><a href="/terms.html">Terms</a></nav>
      </footer>
    </main>
  );
}
